import { getCommonQuickNavPages } from "constants/quickNav/common";
import { APPS_QUICK_NAV_PAGES } from "constants/quickNav/apps";
import { SETTINGS_QUICK_NAV_PAGES } from "constants/quickNav/settings";
import { QuickNavPage } from "constants/quickNav/types";

const SALES_TAX_HOME_PATH = "/sales-tax";

export const SALES_TAX_QUICK_NAV_PAGES: QuickNavPage[] = [
  { name: "Nexus Tracker", path: SALES_TAX_HOME_PATH },
  { name: "Filings", path: "/sales-tax/state-filings" },
  { name: "Registrations", path: "/sales-tax/registrations" },
  { name: "Sales Tax Calculator", path: "/sales-tax/tax-calculator" },
  ...getCommonQuickNavPages(SALES_TAX_HOME_PATH),
  ...SETTINGS_QUICK_NAV_PAGES,
  ...APPS_QUICK_NAV_PAGES.filter(({ path }) => path !== SALES_TAX_HOME_PATH),
];
